import formatStyles from "editor/draggables/formatStyles";
import React, {useEffect, useMemo} from 'react';
import {
  withStyles
} from '@material-ui/core';
import PropTypes from 'prop-types';
import APPLICATION_SETTINGS from "settings";

import InputDraggableStyle from './InputDraggableStyle';
import DraggableWrapper from "../DraggableWrapper/DraggableWrapper";
import TextField from "@material-ui/core/TextField";

const InputDraggable = props => {
  const {
    classes,
    style,
    editorId,
    children,
    draggableProps,
    isChildElem,
    variant,
    placeholder='',
    label='Label',
    textColor,
    labelColor,
    outlineColor,
    value,
    absolutePositioning,
    ...rest
  } = props;

  const {draggableStyles, elementStyles} =
    useMemo(() => formatStyles(style), [style]);

  return (
    <DraggableWrapper
      resizeable
      editorId={editorId}
      style={{
        ...draggableStyles,
        ...draggableProps?.style,
        position: absolutePositioning ? 'absolute' : 'static'
      }}
      isChildElem={isChildElem}
    >
      <TextField
        className={classes.root}
        style={{
          ...elementStyles,
          position: 'static',
        }}
        //disabled
        onFocus={() => {}}
        onChange={() => {}}
        data-editorid={editorId}
        data-asset={true}
        variant={variant || 'outlined'}
        placeholder={placeholder}
        label={label}
        //value={value}
      />
    </DraggableWrapper>
  );
};

InputDraggable.serializedName = 'InputDraggable';

InputDraggable.editorSettings = [
  {
    type: 'prop',
    key: 'breakpoints',
    tooltip: 'Make an asset visible at the chosen breakpoints: desktop, tablet, and/or mobile.',
    default: {
      visibility: {
        desktop: true,
        tablet: true,
        mobile: true
      },
      styleLink: {
        tablet: true,
        mobile: true,
      }
    },
    label: null,
    inputType: 'breakpoint'
  },

  {
    type: 'layout',
    key: 'twoCol',
    tooltip: 'Accepted units: px, %, em, rem, vw, vh',
    label: 'Position/Size',
    elements: [
      {type: 'style', key: 'left', default: '0', label: 'X'},
      {type: 'style', key: 'top', default: '0', label: 'Y'},
      {type: 'style', key: 'width', default: '50px', label: 'W'},
      {type: 'style', key: 'height', default: '50px', label: 'H'},
    ]
  },

  {
    type: 'prop',
    key: 'absolutePositioning',
    tooltip: 'If this is checked, your asset\'s CSS will be written with "position: absolute"',
    label: 'Absolute Positioning',
    default: false,
    inputType: 'boolean'
  },

  {type: 'prop', key: 'variant', default: 'outlined', label: 'Variant', inputType: 'select', options:
      [
        {name: 'Outlined', value: 'outlined'},
        {name: 'Standard', value: 'standard'},
        {name: 'Filled', value: 'filled'}
      ]
  },

  {type: 'prop', key: 'placeholder', default: '', label: 'Placeholder'},

  {type: 'prop', key: 'label', default: 'Label', label: 'Label'},

  //{type: 'prop', key: 'value', default: '', label: 'Value'},

  {
    type: 'layout',
    key: 'font',
    elements: [
      {type: 'style', key: 'fontFamily', default: 'Roboto',inputType: 'select', options: APPLICATION_SETTINGS.CONSTANTS.SUPPORTED_FONTS},
      {type: 'style', key: 'fontWeight', default: '400', inputType: 'select', options: APPLICATION_SETTINGS.CONSTANTS.SUPPORTED_FONT_WEIGHTS},
      {type: 'style', key: 'fontSize', default: '16px'},
    ]
  },

  {
    type: 'prop',
    key: 'outlineColor',
    default: '',
    label: 'Outline Color',
    inputType: 'color',
    inputOptions: {
      defaultColor: ''
    }
  },

  {
    type: 'prop',
    key: 'textColor',
    default: '',
    label: 'Text Color',
    inputType: 'color',
    inputOptions: {
      defaultColor: ''
    }
  },

  {
    type: 'prop',
    key: 'labelColor',
    default: '',
    label: 'Label Color',
    inputType: 'color',
    inputOptions: {
      defaultColor: ''
    }
  },

  {
    type: 'style',
    key: 'background',
    default: '',
    label: null,
    inputType: 'color',
    inputOptions: {
      defaultColor: ''
    }
  },

  {
    type: 'collection',
    label: 'Padding',
    children: [
      {type: 'style', key: 'paddingTop', default: '0px', label: 'Top', horizontal: false},
      {type: 'style', key: 'paddingBottom', default: '0px', label: 'Bottom', horizontal: false},
      {type: 'style', key: 'paddingLeft', default: '0px', label: 'Left', horizontal: false},
      {type: 'style', key: 'paddingRight', default: '0px', label: 'Right', horizontal: false},
    ]
  },

  {
    type: 'collection',
    label: 'Margin',
    children: [
      {type: 'style', key: 'marginTop', default: '0px', label: 'Top', horizontal: false},
      {type: 'style', key: 'marginBottom', default: '0px', label: 'Bottom', horizontal: false},
      {type: 'style', key: 'marginLeft', default: '0px', label: 'Left', horizontal: false},
      {type: 'style', key: 'marginRight', default: '0px', label: 'Right', horizontal: false},
    ]
  },
]

InputDraggable.propTypes = {
  classes: PropTypes.object,
  style: PropTypes.object,
  draggableProps: PropTypes.object,
  editorId: PropTypes.string.isRequired,
  isChildElem: PropTypes.bool,
  children: PropTypes.array,
  variant: PropTypes.string,
  placeholdren: PropTypes.string,
  label: PropTypes.string,
  value:PropTypes.string,
};

export default withStyles(InputDraggableStyle)(InputDraggable);
